import React from 'react';
import _ from 'lodash';
import { BeatLoader } from 'react-spinners';
import ServiceTemplate from './template';
import styles from './styles.module.scss';

const ServiceDetails = ({
  learningCenters,
  plans,
  planId: id,
  selectedLearningCenterId,
  refreshServices,
  history
}) => {
  let planLearningCenters;
  const plan = _.find(plans, ['id', parseInt(id, 10)]);

  if (!plan) return (
    <div className={`${styles.beatloaderOverlay}`}>
      <BeatLoader color="#52b949" />
    </div>
  );

  if (plan.learning_center_ids.length === 0) {
    planLearningCenters = learningCenters;
  } else {
    planLearningCenters =
      _.chain(plan.learning_center_ids)
      .map(id => _.find(learningCenters, ['id', id]))
      .compact()
      .value();
  }

  return (
    <ServiceTemplate
      learningCenters={planLearningCenters}
      plan={plan}
      refreshServices={refreshServices}
      selectedLearningCenterId={selectedLearningCenterId}
      checkoutPath="/marketplace/checkout"
      history={history}
    />
  );
};

export default ServiceDetails;
